import { render, staticRenderFns } from "./inspection-station-carousel.vue?vue&type=template&id=8f4c7eb2&scoped=true"
import script from "./inspection-station-carousel.vue?vue&type=script&lang=js"
export * from "./inspection-station-carousel.vue?vue&type=script&lang=js"
import style0 from "./inspection-station-carousel.vue?vue&type=style&index=0&id=8f4c7eb2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4c7eb2",
  null
  
)

export default component.exports